import StatsTabs from './StatsTabs';

export default StatsTabs;
